import React, { memo, useEffect, useState } from "react";

export const Clock = memo(() => {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const intervalId =setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);
  
  return (
    <div style={{minWidth:180}}>
      {time.toLocaleTimeString("fa-IR", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })}
    </div>
  );
})
